export default "__VITE_ASSET__8b0fd705__"